module.exports = __webpack_public_path__ + "static/media/slider-l2-768.7cb8de67.webp";